import { render } from "./HeaderNav.vue?vue&type=template&id=b08a6986"
import script from "./HeaderNav.vue?vue&type=script&lang=js"
export * from "./HeaderNav.vue?vue&type=script&lang=js"
script.render = render

export default script